import React from 'react'
import { Link } from '../../utils/link'

export const Breadcrumbs = (props: {
  links: {
    title: string
    url: string
  }[]
  style?: 'white'
}) =>
  props.links.length > 0 ? (
    <nav className="breadcrumb" aria-label="Broodkruimels">
      <ul className="breadcrumb__list">
        {props.links.map((item, index) => (
          <li className="breadcrumb__item" key={item.url}>
            {index == props.links.length - 1 ? (
              <span aria-current="location">{item.title}</span>
            ) : (
              <Link url={item.url} className={`breadcrumb__link link--styled-${props.style || 'gray'}`}>
                {item.title}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  ) : (
    <> </>
  )
